import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

const styles = {
  cardHeader: {
    zIndex: "0 !important",
  },
  cardTitleActions: {
    color: "black",
    display: "flex",
    justifyContent: "space-between",
  },
};

// O objetivo desse component é praticamente encapsular os
// imports e evitar repetição sempre que usar o card.
const ECCard = ({ actions, cardHeaderColor, classes, content, hasIcon, icon, iconColor, title, titleActionsClass }) => {
  return (
    <Card>
      <CardHeader className={classes.cardHeader} color={cardHeaderColor} icon={hasIcon}>
        {icon && (
          <CardIcon color={iconColor}>
            {icon}
          </CardIcon>
        )}
        <div className={titleActionsClass || classes.cardTitleActions}>
          <h4>
            {title}
          </h4>
          {actions}
        </div>
      </CardHeader>
      <CardBody>
        {content}
      </CardBody>
    </Card>
  );
};

ECCard.defaultProps = {
  cardHeaderColor: "rose",
  hasIcon: true,
  iconColor: "info",
};

ECCard.propTypes = {
  actions: PropTypes.node,
  cardHeaderColor: PropTypes.oneOf([
    "danger",
    "info",
    "primary",
    "rose",
    "success",
    "warning",
  ]),
  classes: PropTypes.object.isRequired,
  content: PropTypes.node.isRequired,
  hasIcon: PropTypes.bool,
  icon: PropTypes.node,
  iconColor: PropTypes.oneOf([
    "danger",
    "info",
    "primary",
    "rose",
    "success",
    "warning",
  ]),
  title: PropTypes.node,
  titleActionsClass: PropTypes.string,
};

export default withStyles(styles)(ECCard);



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Cards/ECCard.jsx